import { API_ROOT } from '../../config/config'
import { doGet, doPostFiles, doDelete, doPut, doDownload } from './utils'

// const API_ROOT = 'http://localhost:9015/api'

export const getLawDocumentForm = () => {
  // /api/v1/legal/document/form
  const url = `${API_ROOT}/v1/legal/document/form`
  return doGet(url)
}

export const saveLawDocumentForm = (request) => {
  // /api/v1/legal/document/upload
  const url = `${API_ROOT}/v1/legal/document/upload`
  return doPostFiles(url, request)
}

export const deleteLawDocumentForm = (id, projectId) => {
  // /api/v1/legal/document/{id}
  const url = `${API_ROOT}/v1/legal/document/${id}`
  return doDelete(url)
}

export const updateAttachments = (id, request) => {
  // /api/v1/legal/document/{id}
  const url = `${API_ROOT}/v1/legal/document/${id}`
  return doPut(url, request)
}

export const getDownload = (fileId) => {
  // /api/v1/legal/document/download/{fileId}
  const url = `${API_ROOT}/v1/legal/document/download/${fileId}`
  return doDownload(url)
}
